import { createSlice } from '@reduxjs/toolkit';

interface QualityState {
	addGageModalVisible: boolean;
	editGageModalVisible: boolean;
	gageCalibrationsModalVisible: boolean;
}

const initialState: QualityState = {
	addGageModalVisible: false,
	editGageModalVisible: false,
	gageCalibrationsModalVisible: false,
};

export const quality = createSlice({
	name: 'quality',
	initialState,
	reducers: {
		showAddGageModal: (state) => {
			state.addGageModalVisible = true;
		},
		closeAddGageModal: (state) => {
			state.addGageModalVisible = false;
		},
		showEditGageModal: (state) => {
			state.editGageModalVisible = true;
		},
		closeEditGageModal: (state) => {
			state.editGageModalVisible = false;
		},
		showGageCalibrationsModal: (state) => {
			state.gageCalibrationsModalVisible = true;
		},
		closeGageCalibrationsModal: (state) => {
			state.gageCalibrationsModalVisible = false;
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	showAddGageModal,
	closeAddGageModal,
	showEditGageModal,
	closeEditGageModal,
	showGageCalibrationsModal,
	closeGageCalibrationsModal,
} = quality.actions;

export default quality.reducer;
